import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { isNotEmptyArray } from 'utils/misc';
import { RadioButton, RadioButtonGroup } from '@ds/react-components';
import * as Styled from './CancellationType.styled';

const CancellationType = (props) => {
  const { cancellationOptions, formControl } = props;

  return (
    <Controller
      name={'cancellationOption'}
      rules={{ required: true }}
      control={formControl}
      render={({ onChange, value }) => (
        <RadioButtonGroup
          label={'Cancellation type'}
          onChange={(newValue) => {
            onChange(parseInt(newValue));
          }}
          value={value}>
          <RadioButtonGroup.Body>
            {cancellationOptions.map(
              ({ label, subLabels, value: optionValue }) => (
                <RadioButton
                  value={optionValue}
                  key={optionValue}
                  labelId={`cancellation-type-${optionValue}`}
                  label={
                    !isNotEmptyArray(subLabels) ? (
                      label
                    ) : (
                      <Styled.LabelContainer>
                        <Styled.Label id={`cancellation-type-${optionValue}`}>
                          {label}
                        </Styled.Label>
                        <Styled.SubLabelContainer>
                          {subLabels.map((val, index) => (
                            <Styled.SubLabel key={index}>{val}</Styled.SubLabel>
                          ))}
                        </Styled.SubLabelContainer>
                      </Styled.LabelContainer>
                    )
                  }
                />
              )
            )}
          </RadioButtonGroup.Body>
        </RadioButtonGroup>
      )}
    />
  );
};

CancellationType.propTypes = {
  cancellationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      subLabels: PropTypes.arrayOf[PropTypes.string],
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
    })
  ).isRequired,
  formControl: PropTypes.object.isRequired,
};

export default CancellationType;
